import React from 'react'
import Rkap from '../Rkap'
import { Link, useLocation, useParams } from 'react-router-dom';
import { PlaylistAddCircle } from '@mui/icons-material';

const RkapVariable = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Rkap>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/rkap/variable/form`} className={` sub-menu-item ${split[4] === 'form'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Input Variabel RKAP</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/rkap/variable/data`} className={` sub-menu-item ${split[4] === 'data'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Data Variabel RKAP</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Rkap>
    )
}

export default RkapVariable
